import { publicApi } from '../../client';

export interface SendRecoveryCodeRequestParams {
  email: string;
}

export const sendRecoveryCodeRequest = async (params: SendRecoveryCodeRequestParams) => {
  await publicApi.post('/api/v1/auth/password-recovery', params);
};
